import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const ImageButton = styled(Button)(({ theme }) => ({
  padding: 0,
  minWidth: 0,
  "& img": {
    width: "100%", // Set the width of the image
    height: "auto",
    borderRadius: "8px", // Optional: to add rounded corners
    transition: "transform 0.3s ease",
  },
  "&:hover img": {
    transform: "scale(1.1)", // Adds a zoom effect on hover
  },
}));

const Card = () => {
  return (
    <>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <ImageButton
          href="https://minemi.ai/home-loan/check-eligibility/" // The link you want to redirect to
          target="_blank" // Opens the link in a new tab
          rel="noopener noreferrer"
        >
          <img
            src="./images/Eligibilty-Banner.webp"
            alt="check eligibility image"
          />
        </ImageButton>
      </div>
    </>
  );
};

export default Card;
